import React from "react";

import { Link } from "react-router-dom";

import letsLearn from "../assets/images/lets_learn.png";
import chessWiz from "../assets/images/chess_wiz.png";
import snakeLadder from "../assets/images/snakeandladder.png";
import dailyDose from "../assets/images/dailydose.png";
import fredhour from "../assets/images/fredhour_crm.png";
import revive from "../assets/images/revive.png";

const Projects = () => {

  const projects = [
    {
      name: "Let's Learn",
      image: letsLearn,
      description:
        "An interactive kids learning app designed to build reading, writing, drawing, and speaking skills through fun activities.",
      android: "https://play.google.com/store/apps/details?id=com.fredhour.letslearn",
      ios: "https://apps.apple.com/app/lets-learn-kids/id6761774308"
    },
    {
      name: "ChessWiz",
      image: chessWiz,
      description:
        "A smart chess learning platform where kids can play with AI bots or challenge players online to improve their strategy.",
      android: "#",
      ios: "#"
    },
    {
      name: "Snake & Ladder",
      image: snakeLadder,
      description:
        "A classic kids board game with modern features including online multiplayer and local play with friends and family.",
      android: "#"
    },
    {
      name: "DailyDose",
      image: dailyDose,
      description:
        "A lifestyle and knowledge platform where users can explore inspiring articles, tips, and daily reading content.",
      android: "",
      ios: "#"
    },
    {
      name: "Fred Hour CRM",
      image: fredhour,
      description:
        "A powerful CRM platform for consultancies and offices to manage leads, tasks, customers, documents and operations.",
      web: "https://fredhour-crm.web.app/"
    },
    {
      name: "Revive",
      image: revive,
      description:
        "A rehabilitation management system that tracks residents, staff, petty cash accounts, tiffin schedules and daily reports.",
      web: "https://reviveuat.fredhour.com/"
    }
  ];

  return (
    <>
      {/* -------- Hero Section -------- */}

      <div
        className="d-flex justify-content-start align-items-center px-3 px-lg-5 pb-4"
        style={{
          minHeight: "60vh",
          paddingTop: "120px",
          backgroundColor: "#153555",
          color: "white"
        }}
      >
        <div>
          <h1
            className="fw-bold mb-4"
            style={{
              fontSize: "55px",
              fontWeight: "900",
              lineHeight: "1.2"
            }}
          >
            Our Projects
          </h1>

          <p
            style={{
              fontSize: "18px",
              color: "#cccccc",
              maxWidth: "600px"
            }}
          >
            A collection of mobile and web applications we have built to
            simplify lives, empower businesses and inspire innovation.
          </p>
        </div>
      </div>

      {/* -------- Projects Section -------- */}

      <div className="container my-5">

        <div className="text-center mb-5">
          <h2
            className="fw-bold"
            style={{ fontSize: "35px", color: "#333333" }}
          >
            Our Applications
          </h2>

          <p
            style={{
              fontSize: "14px",
              color: "#555555",
              maxWidth: "650px",
              margin: "0 auto"
            }}
          >
            Mobile apps and web systems built to solve real problems and deliver
            meaningful digital experiences.
          </p>
        </div>

        <div className="row g-4">

          {projects.map((project, index) => (
            <div className="col-md-4" key={index}>
              <div
                className="p-4 h-100"
                style={{
                  backgroundColor: "white",
                  borderRadius: "15px",
                  textAlign: "center",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  border: "1px solid #cfd8e3"
                }}
              >

                <img
                  src={project.image}
                  alt={project.name}
                  className="mb-3 rounded"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "contain"
                  }}
                />

                <h5 className="fw-bold mb-2" style={{ color: "#333333" }}>
                  {project.name}
                </h5>

                <p style={{ fontSize: "14px", color: "#555555" }}>
                  {project.description}
                </p>

                {/* Buttons */}

                <div className="d-flex justify-content-center gap-2 flex-wrap">

                  {project.android && (
                    <a
                      href={project.android}
                      className="btn btn-sm text-white"
                      style={{ backgroundColor: "#FF8F1C" }}
                    >
                      Android
                    </a>
                  )}

                  {project.ios && (
                    <a
                      href={project.ios}
                      className="btn btn-sm btn-outline-dark"
                    >
                      iOS
                    </a>
                  )}

                  {project.web && (
                    <a
                      href={project.web}
                      className="btn btn-sm text-white"
                      style={{ backgroundColor: "#FF8F1C" }}
                    >
                      Open Web App
                    </a>
                  )}

                </div>

              </div>
            </div>
          ))}

        </div>
      </div>
    </>
  );
};

export default Projects;